"use client";

import dynamic from "next/dynamic";
import { Suspense } from "react";
import { useCompaniesMap } from "@/hooks/useCompaniesMap";
import MapLoader from "./_components/MapLoader";
import { ERoles } from "@/data/roles";
import RoleGuard from "@/components/auth/RoleGuard";

const CompaniesMapPage = dynamic(() => import("./_components/CompaniesMapPage"), { ssr: false });

export default function CompaniesClient() {
  const { companies, metaData, isLoading, didFetchCompanies, handleBoundingBoxChange } = useCompaniesMap();

  if (!didFetchCompanies || metaData.totalCompanies === undefined) {
    return <MapLoader />;
  }

  return (
    <Suspense fallback={<MapLoader />}>
      <RoleGuard
        allowedRoles={[ERoles.OrganizationAdmin, ERoles.OrganizationUser, ERoles.SuperAdmin]}
        fallback={
          <CompaniesMapPage
            showCompanyInfo
            showFilters
            metaData={metaData}
            handleBoundingBoxChange={handleBoundingBoxChange}
            companies={companies}
            isLoading={isLoading}
            isAdmin={false}
          />
        }
      >
        <CompaniesMapPage
          showCompanyInfo
          showFilters
          metaData={metaData}
          handleBoundingBoxChange={handleBoundingBoxChange}
          companies={companies}
          isLoading={isLoading}
          isAdmin={true}
        />
      </RoleGuard>
    </Suspense>
  );
}
